import moment from 'jalali-moment';
import { TFunction } from 'i18next';
import { envConfig } from '@/configs';

const ACTIVITY_TYPE_ONLINE_DELIVERY = [
  'OnlineFoodDeliveryByCardType',
  'OnlineFoodDeliveryByCvv2Type',
  'OnlineFoodDeliveryByFaceMatchingType',
  'OnlineFoodDeliveryByForgottenCodeType',
  'OnlineFoodDeliveryByCvv2WithFaceMatchingType',
  'OnlineFoodDeliveryByCardWithFaceMatchingType',
  'OnlineFoodDeliveryByForgottenCodeWithFaceMatchingType',
];

export function mapItems(items: ActivityReportEntity[], findVariantById = undefined, t: TFunction): ActivityReportItemEntity[] {

  const result: ActivityReportItemEntity[] = [];
  const txtUnknown = t('common:labels.unknown');
  const txtYes = t('common:labels.yes');
  const txtNo = t('common:labels.no');

  function detailItem(title: string, value: any) {
    return ({
      title,
      value: value || txtUnknown
    });
  }

  function fieldValueText(key: string): any {
    return (t(`report:activity-report-activity-fields.${key}`, { returnObjects: true, defaultValue: '' }));
  }

  function fieldTypeText(key: string) {
    return (t(`report:activity-report-action-types.${key}`));
  }

  for (const item of items) {
    const fullClassname = item.activityTypeClassName;
    const classname = fullClassname.substring(
      fullClassname.lastIndexOf('.') + 1,
      fullClassname.length
    );

    const data = JSON.parse(item.activityTypeJson);

    const occurDate = moment(new Date(item.occurDate)).format('jYYYY/jMM/jDD');
    const occurTime = moment(new Date(item.occurDate)).format('HH:mm');
    const serveDate = data.serveDate ? moment(new Date(data.serveDate)).format('jYYYY/jMM/jDD') : '';

    const newItem: ActivityReportItemEntity = {
      name: fieldTypeText(classname) || txtUnknown,
      price: data['price'] || data['diff'] || data['sentCredit'] || data['amount'] || '-',
      date: occurDate,
      time: occurTime,
      fullDate: occurDate + ' ' + occurTime,
      serveDate: serveDate,
      details: {
        firstName: detailItem(fieldValueText('firstName'), item.user && item.user.firstName),
        lastName: detailItem(fieldValueText('lastName'), item.user && item.user.lastName),
        groupName: detailItem(fieldValueText('groupName'), item.groupName),
        username: detailItem(fieldValueText('username'), item.user && item.user.username),
      }
    };

    const propertyArray = Object.getOwnPropertyNames(data).filter((item) => (
      !['type', 'actionType', 'issueDate', 'progId', 'selfCode'].includes(item)
    ));

    let variant = findVariantById ? findVariantById(Number(data.selfCode)) : 'nurture';

    if (variant === 'unknown') {
      variant = 'nurture';
    }

    for (let i = 0; i < propertyArray.length; i++) {
      if (['dailySale', 'consumed'].includes(propertyArray[i])) {
        // DailySale is a boolean type which should be treated as positive negative value
        newItem.details[propertyArray[i]] = {
          title: fieldValueText(propertyArray[i]) as any,
          value: data[propertyArray[i]] ? txtYes : txtNo,
        };
      }
      else if (['price', 'subsidyAmount', 'actualSubsidyAmount', 'remainCredit'].includes(propertyArray[i])) {
        newItem.details[propertyArray[i]] = {
          title: fieldValueText(propertyArray[i]) as any,
          value: envConfig.ui.removeCurrency ?
            Math.ceil(data[propertyArray[i]] / 10) : // convert to toman if needed
            data[propertyArray[i]],
        };
      }
      else {
        const val = fieldValueText(propertyArray[i]);
        if (typeof val === 'object') {
          newItem.details[propertyArray[i]] = {
            title: val?.[variant],
            value: data[propertyArray[i]],
          };
        }
        else {
          newItem.details[propertyArray[i]] = {
            title: val,
            value: data[propertyArray[i]],
          };
        }
      }
    }

    if (ACTIVITY_TYPE_ONLINE_DELIVERY.includes(classname)) {

      newItem.details['teammateUsername'] = {
        title: fieldValueText('teammateUsername'),
        value: (item.operator && item.operator?.username ? item.operator?.username : '-') || '-',
      };

      newItem.details['teammateFullname'] = {
        title: fieldValueText('teammateFullname'),
        value: (item.operator && item.operator?.firstName ? item.operator?.lastName : '-') || '-',
      };
    }
    else {
      newItem.details['operatorFirstName'] = {
        title: fieldValueText('operatorFirstName'),
        value: (item.operator && item.operator.firstName) || '-',
      };
      newItem.details['operatorLastName'] = {
        title: fieldValueText('operatorLastName'),
        value: (item.operator && item.operator.lastName) || '-',
      };
      newItem.details['operatorUsername'] = {
        title: fieldValueText('operatorUsername'),
        value: (item.operator && item.operator.lastName) || '-',
      };
    }

    if (newItem.details.serveDate) {
      newItem.details.serveDate.value = serveDate;
    }

    result.push(newItem);
  }


  return result;
}
